import { Polygon } from "react-leaflet";
import { MasterIndex, Models } from "verdi-web-client";

import type MapEntityBase from "../../map-entities/map-entity-base";

interface ZoneHighlightPolygonProps {
    mapEntity?: MapEntityBase;
}

export function ZoneHighlightPolygon({ mapEntity }: ZoneHighlightPolygonProps) {
    if (!mapEntity) {
        return null;
    }

    const { model } = mapEntity;
    const connectedZones =
        model?.connectedZones ?? model?.connectedZoneIDs?.map((id: string) => MasterIndex.zone.byID[id]) ?? [];

    // Only highlight once for each zone
    const hasIdAndPolygon = (z: Models.Zone) => z?.id && z?.polygon;
    const uniqueConnectedZones = Array.from(
        new Map(connectedZones.filter(hasIdAndPolygon).map((z: Models.Zone) => [z.id, z])).values(),
    ) as Models.Zone[];

    return (
        <div key={`${mapEntity?.id}-highlight-polygon`}>
            {uniqueConnectedZones?.map((zone: Models.Zone) => (
                <Polygon
                    key={`${zone?.id}-highlight-polygon`}
                    positions={zone.polygon}
                    pathOptions={{
                        color: "#c4dd98",
                        weight: 3,
                        fillOpacity: 0.2,
                        interactive: false, // purely visual — clicks must reach the zone polygon underneath
                    }}
                />
            ))}
        </div>
    );
}
